import { FC, Fragment } from "react";

interface MultiLineTextProps {
  lines: (string | undefined | null)[];
  as?: "p" | "div" | "span";
}

const MultiLineText: FC<MultiLineTextProps> = ({ lines, as = "p" }) => {
  const validLines = lines.filter(Boolean);
  const Wrapper = as;

  return (
    <Wrapper>
      {validLines.map((line, index) => (
        <Fragment key={index}>
          {line}
          {index < validLines.length - 1 && <br />}
        </Fragment>
      ))}
    </Wrapper>
  );
};

export default MultiLineText;
